import { svg } from "config/svgStyles";

export const notifications = {};

export const notification =
  ({
    notifcationType = "notification",
    hasIcon = false,
    hasCloseButton = false,
  }) =>
  ({ isMobile }) => ({
    color: "white",
    background: notifcationType === "notification" ? "primary" : "grey5",
    borderRadius: isMobile ? "4px" : "8px",
    padding: isMobile ? "10px" : "20px",
    position: "relative",

    borderTopLeftRadius: hasCloseButton && "0",
    borderTopRightRadius: hasCloseButton && "0",

    pl: hasIcon ? (isMobile ? "36px" : "64px") : null,
    pr: hasCloseButton ? (isMobile ? "36px" : "64px") : null,

    fontFamily: "roboto",
    fontWeight: "400",
    fontSize: isMobile ? "12px" : "14px",
    lineHeight: "1.33",
    letterSpacing: "0.1em",

    "> svg": {
      position: "absolute",
      left: isMobile ? "10px" : "20px",
      top: "50%",
      width: isMobile ? "16px" : "24px",
      height: isMobile ? "16px" : "24px",
      transform: "translateY(-50%)",
      ...svg("white"),
    },
  });

export const closeButton = ({ isMobile }) => ({
  position: "absolute",
  top: "50%",
  right: isMobile ? "10px" : "26px",
  width: isMobile ? "16px" : "24px",
  height: isMobile ? "16px" : "24px",
  transform: "translateY(-50%)",
  ...svg("white"),
});
